import { Component, OnInit } from "@angular/core";
import { AjaxService } from "../../../service/ajax.service";
import { API, BASE_API } from "src/environments/environment";
import { UserService } from "src/app/services/user.service";
import { HttpClient } from "@angular/common/http";
import { UtilService } from "src/app/service/util.service";

interface Documento {
  id: number;
  nome: string;
  tipo: string;
  dataUpload: Date;
  status: string;
  url: string;
}

@Component({
  selector: "app-documentos",
  templateUrl: "./documentos.component.html",
  styleUrls: ["./documentos.component.scss"],
})
export class DocumentosComponent implements OnInit {
  documentos: Documento[] = [];
  novosDocumentos: File[] = [];
  loading: boolean = false;
  isUploading: boolean = false;
  errorMessage: string = "";
  successMessage: string = "";
  user: any;

  constructor(
    private ajaxService: AjaxService,
    private auth: UserService,
    private http: HttpClient,
    public util: UtilService
  ) {}

  ngOnInit() {
    this.user = this.auth.getUser();
    this.carregarDocumentos();
  }

  carregarDocumentos() {
    this.loading = true;
    this.errorMessage = "";

    this.util.showLoading();
    this.ajaxService
      .get(API + "Arquivos/Arquivos?ID_USUARIO=" + this.user.Id)
      .subscribe({
        next: (response) => {
          this.util.closeLoading();
          if (response.data && Array.isArray(response.data)) {
           
            this.documentos = response.data.map((doc) => ({
              id: doc.iD_DOCUMENTO,
              nome: doc.nome,
              dataUpload: new Date(doc.datA_CADASTRO),
              url: doc.path,
            }));
          }
          this.loading = false;
        },
        error: (error) => {
          this.util.closeLoading();
          console.error("Erro ao carregar documentos:", error);
          this.errorMessage = "Erro ao carregar documentos. Tente novamente.";
          this.loading = false;
        },
      });
  }

  baixarDocumento(documento: Documento) {
    window.open(BASE_API + documento.url.replace("/clientes", ""), "_blank");
  }

  excluirDocumento(documento: Documento) {
    if (confirm("Tem certeza que deseja excluir este documento?")) {
      this.loading = true;
      this.errorMessage = "";

      this.ajaxService
        .delete(API + "Documento/DeleteDocumento?ID_DOCUMENTO=" + documento.id)
        .subscribe({
          next: (response) => {
            this.successMessage = "Documento excluído com sucesso!";
            this.carregarDocumentos();
          },
          error: (error) => {
            console.error("Erro ao excluir documento:", error);
            this.errorMessage = "Erro ao excluir documento. Tente novamente.";
            this.loading = false;
          },
        });
    }
  }

  formatarData(data: Date): string {
    return data.toLocaleDateString("pt-BR");
  }

  getStatusClass(status: string): string {
    switch (status.toLowerCase()) {
      case "aprovado":
        return "status-aprovado";
      case "pendente":
        return "status-pendente";
      case "rejeitado":
        return "status-rejeitado";
      default:
        return "";
    }
  }

  onFileSelected(event: any): void {
    const files = event.target.files;
    if (files) {
      for (let i = 0; i < files.length; i++) {
        this.novosDocumentos.push(files[i]);
      }
    }
  }

  removeDocumento(index: number): void {
    this.novosDocumentos.splice(index, 1);
  }

  getDados() {
    return  {
      ID_USUARIO: this.user.Id,
    };
  }
  

  onSubmit(): void {
    if (this.novosDocumentos.length === 0) return;

    let dadosQrcode = this.getDados();
    let formData = this.util.jsonToFormData(dadosQrcode);
    // Adicionar documentos
    this.novosDocumentos.forEach((doc, index) => {
      formData.append(`Arquivo`, doc);
    });

    debugger;
    this.util.showLoading();
    var url = API + "Arquivos/Arquivos/AdicionarArquivos";
    this.ajaxService.postFile(url, formData).subscribe({
      next: () => {
        this.util.closeLoading();
        this.successMessage = "Documentos enviados com sucesso!";
        this.novosDocumentos = [];
        this.carregarDocumentos();
      },
      error: (error) => {
        this.util.closeLoading();
        this.errorMessage = "Erro ao enviar documentos. Tente novamente.";
        console.error("Erro no upload:", error);
      },
      complete: () => {
        this.util.closeLoading();
        this.isUploading = false;
      },
    });
  }
}
